import { createPaginator } from "@smithy/core";
import { GetFaceDetectionCommand, } from "../commands/GetFaceDetectionCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateGetFaceDetection = createPaginator(RekognitionClient, GetFaceDetectionCommand, "NextToken", "NextToken", "MaxResults");
